import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Avatar from "../assets/AvatarProfile.png";
import { usersEndpoint } from "../constants";

const UserProfile = () => {
  const { id } = useParams();
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [location, setLocation] = useState("");
  const [profileInfo, setProfileInfo] = useState("");
  const [pictureFile, setPictureFile] = useState(null);
  const [bannerPictureFile, setBannerPictureFile] = useState(null);

  const fileInputRef = useRef(null);
  const bannerFileInputRef = useRef(null);

  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${usersEndpoint}${id}/`, {
          headers: {
            'Authorization': `Token ${token}`,
          },
        });
        setProfileData(response.data);
        setFirstName(response.data.first_name || "");
        setLastName(response.data.last_name || "");
        setLocation(response.data.profile.location || "");
        setProfileInfo(response.data.profile.profile_info || "");
      } catch (err) {
        setError("Failed to load profile.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (token && id) {
      fetchProfile();
    }
  }, [token, id]);

  const handleDivClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleBannerDivClick = () => {
    if (bannerFileInputRef.current) {
      bannerFileInputRef.current.click();
    }
  };

  const handlePictureChange = (event) => {
    setPictureFile(event.target.files[0]);
  };

  const handleBannerPictureChange = (event) => {
    setBannerPictureFile(event.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const formData = new FormData();
    formData.append('first_name', firstName);
    formData.append('last_name', lastName);

    const profileData = {
        location: location,
        profile_info: profileInfo
    }

    if (pictureFile) {
        profileData.picture = pictureFile;
    }
    if (bannerPictureFile) {
        profileData.banner_picture = bannerPictureFile;
    }

    formData.append('profile', JSON.stringify(profileData))


    try {
      const response = await axios.patch(`${usersEndpoint}${id}/`, formData, {
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      setProfileData(response.data);
      alert("Profile updated successfully!");
    } catch (err) {
      setError("Failed to update profile.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="text-center py-8">Loading profile...</div>;
  }

  if (error) {
    return <div className="text-center py-8 text-red-500">Error: {error}</div>;
  }

  if (!profileData) {
    return <div className="text-center py-8">No profile data available.</div>;
  }

  return (
    <div>
      <div className="flex justify-start items-start flex-row">
        <div className=" flex-1 flex-col gap-6 ">
          <div className="flex self-stretch justify-start items-start flex-col gap-8  pb-[48px]   w-full">
            <div className="flex self-stretch justify-start items-start flex-col gap-[48px] pb-[48px]">
              <div className="w-full relative">
                <div
                  className="w-full h-54 bg-linear-to-r from-sky-300 to-white cursor-pointer"
                  onClick={handleBannerDivClick}
                >
                  {profileData.profile.banner_picture ? (
                    <img
                      src={profileData.profile.banner_picture}
                      alt="Banner"
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full bg-gray-200 flex items-center justify-center text-gray-500">Upload Banner</div>
                  )}
                  <input
                    type="file"
                    ref={bannerFileInputRef}
                    accept="image/*"
                    className="hidden"
                    onChange={handleBannerPictureChange}
                  />
                </div>

                <div className="absolute top-[160px] left-[150px]">
                  <div className="flex  items-end justify-start ">
                    <div className="flex justify-center items-center relative">
                      <img src={profileData.profile.picture || Avatar} alt="" className="w-32 h-32 rounded-full object-cover border-4 border-white" />
                      <div className="absolute bottom-[0px] right-[0px] cursor-pointer" onClick={handleDivClick}>
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_1330_4937)">
                            <path
                              d="M24.7109 5.66812C25.0149 6.40315 25.5982 6.9874 26.3328 7.29243L28.9086 8.35935C29.6437 8.66383 30.2277 9.24785 30.5322 9.98294C30.8366 10.718 30.8366 11.544 30.5322 12.279L29.466 14.853C29.1614 15.5884 29.1610 16.4151 29.4670 17.1502L30.5313 19.7234C30.6822 20.0874 30.7599 20.4777 30.76 20.8718C30.7601 21.266 30.6825 21.6562 30.5316 22.0204C30.3808 22.3845 30.1597 22.7153 29.8810 22.994C29.6022 23.2726 29.2713 23.4936 28.9072 23.6443L26.3332 24.7105C25.5982 25.0144 25.0140 25.5978 24.7089 26.3323L23.6420 28.9081C23.3375 29.6432 22.7535 30.2272 22.0184 30.5317C21.2833 30.8362 20.4574 30.8362 19.7223 30.5317L17.1484 29.4655C16.4133 29.1618 15.5877 29.1624 14.8530 29.4673L12.2772 30.5327C11.5426 30.8364 10.7173 30.8362 9.98286 30.5319C9.24837 30.2277 8.66467 29.6444 8.35998 28.9101L7.29274 26.3335C6.98882 25.5985 6.40545 25.0143 5.67088 24.7092L3.09511 23.6423C2.36034 23.338 1.77649 22.7543 1.47190 22.0196C1.16730 21.285 1.16689 20.4594 1.47075 19.7245L2.53691 17.1505C2.84064 16.4154 2.84002 15.5898 2.53518 14.8552L1.47056 12.2775C1.31961 11.9135 1.24189 11.5232 1.24183 11.1291C1.24176 10.7349 1.31936 10.3447 1.47019 9.98054C1.62101 9.61641 1.84211 9.28558 2.12085 9.00693C2.39958 8.72828 2.73049 8.50729 3.09466 8.35658L5.66859 7.29043C6.40298 6.98677 6.98688 6.40414 7.29213 5.67041L8.35905 3.09464C8.66354 2.35955 9.24756 1.77553 9.98264 1.47105C10.7177 1.16657 11.5437 1.16657 12.2787 1.47105L14.8527 2.5372C15.5878 2.84094 16.4134 2.84032 17.1481 2.53548L19.7249 1.4727C20.4599 1.16839 21.2857 1.16845 22.0206 1.47287C22.7555 1.7773 23.3395 2.36115 23.6440 3.09604L24.7113 5.67259L24.7109 5.66812Z"
                              fill="#2E90FA"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M22.2665 11.8068C22.4803 11.471 22.5519 11.0641 22.4656 10.6755C22.3794 10.287 22.1423 9.94857 21.8065 9.7348C21.4708 9.52104 21.0638 9.44941 20.6753 9.53568C20.2867 9.62194 19.9483 9.85904 19.7345 10.1948L13.8605 19.4248L11.1725 16.0648C10.924 15.754 10.5622 15.5546 10.1667 15.5105C9.77118 15.4664 9.37436 15.5813 9.06352 15.8298C8.75269 16.0783 8.55331 16.4401 8.50923 16.8356C8.46516 17.2311 8.58001 17.628 8.82852 17.9388L12.8285 22.9388C12.9776 23.1254 13.1691 23.2737 13.3870 23.3713C13.6049 23.4690 13.8430 23.5132 14.0815 23.5003C14.3200 23.4874 14.5519 23.4177 14.7580 23.2971C14.9641 23.1765 15.1385 23.0084 15.2665 22.8068L22.2665 11.8068Z"
                              fill="white"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1330_4937">
                              <rect width="32" height="32" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <input
                          type="file"
                          ref={fileInputRef}
                          accept="image/*"
                          className="hidden"
                          onChange={handlePictureChange}
                        />
                      </div>
                    </div>

                    <div className=" flex justify-start flex-col gap-1">
                      <p className=" text-[#181D27] text-2xl  font-semibold">
                        {profileData.first_name} {profileData.last_name}
                      </p>
                      <p className=" text-[#535862] ">{profileData.email}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex self-stretch justify-start items-center flex-col">
                <div className="flex self-stretch justify-start items-start flex-row gap-6">
                  <div className="flex flex-1 justify-start items-start flex-col gap-5 pt-[64px]"></div>
                </div>
              </div>
              <div className="flex self-stretch justify-start items-start flex-col gap-8 pt-4">
                <div className="flex self-stretch justify-start items-start flex-col gap-6 px-[32px]">
                  <div className="flex self-stretch justify-start items-start flex-col gap-5">
                    <div className="flex flex-wrap self-stretch justify-start items-start flex-row gap-y-4 gap-x-8">
                      <div className="min-w-[200px] max-w-[280px] flex flex-1 justify-start items-start flex-col">
                        <div className="flex justify-start items-center flex-row gap-0.5">
                          <span className="text-[#414651] text-sm  font-semibold">
                            Personal info
                          </span>
                        </div>
                        <p className="self-stretch text-[#535862] text-sm ">
                          Update your photo and personal details.
                        </p>
                      </div>
                      <div className="min-w-[560px] max-w-[720px] flex flex-1 justify-start items-start flex-col bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                        <form onSubmit={handleSubmit} className="flex self-stretch justify-start items-start flex-col gap-6 p-[24px]">
                          <div className="flex self-stretch justify-start items-start flex-row gap-6">
                            <div className="flex flex-1 justify-start items-start flex-col gap-1.5">
                              <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
                                <div className="flex justify-start items-start flex-row gap-0.5">
                                  <span className="text-[#414651] text-sm  font-medium">
                                    First name
                                  </span>
                                  <span className="text-[#009C97] text-sm  font-medium">
                                    *
                                  </span>
                                </div>
                                <div className="flex self-stretch justify-start items-center flex-row gap-2 py-2.5 px-3.5 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                                  <div className="flex flex-1 justify-start items-center flex-row gap-2">
                                    <input
                                      type="text"
                                      placeholder="First name.."
                                      className=" outline-none w-full text-gray-600"
                                      value={firstName}
                                      onChange={(e) => setFirstName(e.target.value)}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="flex flex-1 justify-start items-start flex-col gap-1.5">
                              <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
                                <div className="flex justify-start items-start flex-row gap-0.5">
                                  <span className="text-[#414651] text-sm  font-medium">
                                    Last name
                                  </span>
                                  <span className="text-[#009C97] text-sm  font-medium">
                                    *
                                  </span>
                                </div>
                                <div className="flex self-stretch justify-start items-center flex-row gap-2 py-2.5 px-3.5 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                                  <div className="flex flex-1 justify-start items-center flex-row gap-2">
                                    <input
                                      type="text"
                                      placeholder="Last name.."
                                      className=" outline-none w-full text-gray-600"
                                      value={lastName}
                                      onChange={(e) => setLastName(e.target.value)}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
                            <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
                              <div className="flex justify-start items-start flex-row gap-0.5">
                                <span className="text-[#414651] text-sm  font-medium">
                                  Location
                                </span>
                                <span className="text-[#009C97] text-sm  font-medium">
                                  *
                                  </span>
                                </div>
                                <div className="flex self-stretch justify-start items-start flex-row bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                                  <div className="flex flex-1 justify-start items-center flex-row gap-2 py-2.5 pr-3.5 pl-3">
                                    <input
                                      type="text"
                                      placeholder="Location.."
                                      className="text-gray-700 w-full outline-none"
                                      value={location}
                                      onChange={(e) => setLocation(e.target.value)}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
                              <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
                                <div className="flex justify-start items-start flex-row gap-0.5">
                                  <span className="text-[#414651] text-sm  font-medium">
                                    Profile Info
                                  </span>
                                </div>
                                <div className="flex self-stretch justify-start items-start flex-row bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                                  <div className="flex flex-1 justify-start items-center flex-row gap-2 py-2.5 pr-3.5 pl-3">
                                    <textarea
                                      placeholder="Tell us about yourself.."
                                      className="text-gray-700 w-full outline-none"
                                      value={profileInfo}
                                      onChange={(e) => setProfileInfo(e.target.value)}
                                      rows="4"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="flex self-stretch justify-end items-center flex-row gap-4 px-[24px]">
                              <div className="flex flex-1 justify-end items-center flex-row gap-3">
                                <div className="flex justify-center items-center flex-row gap-1 py-2.5 px-3.5  border border-gray-300 rounded-lg  cursor-pointer">
                                  <div className="flex justify-center items-center flex-row px-0.5">
                                    <span className="text-[#414651] text-sm  font-semibold">
                                      Cancel
                                    </span>
                                  </div>
                                </div>
                                <button type="submit" className="flex justify-center items-center flex-row gap-1 py-2.5 px-3.5 bg-[#009C97] border-solid border-[undefined] border-2 rounded-lg cursor-pointer">
                                  <div className="flex justify-center items-center flex-row px-0.5">
                                    <span className="text-[#FFFFFF] text-sm  font-semibold">
                                      Save changes
                                    </span>
                                  </div>
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default UserProfile;
